// ==================== 青云剑宗技能 ====================
const swordSkills = [
    {
        id: 'sword_basic',
        name: '破风斩',
        faction: 'sword',
        cooldown: 0,
        mpCost: 0,
        damageType: 'physical',
        damageRatio: 1.0,
        range: 2.5,
        radius: 0,
        targetType: 'enemy',
        duration: 0,
        levelReq: 1,
        description: '基础平砍，每3次触发剑气波造成前方扇形伤害',
    },
    {
        id: 'sword_dash',
        name: '惊鸿掠影',
        faction: 'sword',
        cooldown: 8,
        mpCost: 20,
        damageType: 'physical',
        damageRatio: 0,
        range: 10,
        radius: 0,
        targetType: 'enemy',
        duration: 3,
        levelReq: 1,
        description: '闪到目标身后，下次攻击暴击率+50%',
        effects: [{ type: 'buff_atk', value: 0.5, duration: 3 }],
    },
    {
        id: 'sword_storm',
        name: '万剑归宗',
        faction: 'sword',
        cooldown: 12,
        mpCost: 40,
        damageType: 'physical',
        damageRatio: 0.6,
        range: 0,
        radius: 5,
        targetType: 'self',
        duration: 3,
        levelReq: 5,
        description: '召唤剑气环绕自身3秒，每0.5s对周围敌人造成伤害',
    },
    {
        id: 'sword_beam',
        name: '一剑寒光',
        faction: 'sword',
        cooldown: 6,
        mpCost: 25,
        damageType: 'physical',
        damageRatio: 1.8,
        range: 15,
        radius: 0,
        targetType: 'direction',
        duration: 0,
        levelReq: 8,
        description: '射出直线剑光，命中减速30%持续2s',
        effects: [{ type: 'slow', value: 0.3, duration: 2 }],
    },
    {
        id: 'sword_ult',
        name: '天罡剑阵',
        faction: 'sword',
        cooldown: 30,
        mpCost: 80,
        damageType: 'physical',
        damageRatio: 0.8,
        range: 0,
        radius: 8,
        targetType: 'self',
        duration: 5,
        levelReq: 15,
        description: '布下剑阵，阵内敌人持续受伤且无法使用位移技能',
        effects: [{ type: 'silence', value: 1, duration: 5 }],
    },
    {
        id: 'sword_shield',
        name: '御剑护体',
        faction: 'sword',
        cooldown: 20,
        mpCost: 30,
        damageType: 'physical',
        damageRatio: 0,
        range: 0,
        radius: 0,
        targetType: 'self',
        duration: 6,
        levelReq: 10,
        description: '剑气护盾，吸收最大生命15%的伤害，持续6s',
        effects: [{ type: 'shield', value: 0.15, duration: 6 }],
    },
];
// ==================== 天玄道宗技能 ====================
const daoSkills = [
    {
        id: 'dao_basic',
        name: '三昧真火',
        faction: 'dao',
        cooldown: 0,
        mpCost: 0,
        damageType: 'magical',
        damageRatio: 1.0,
        range: 12,
        radius: 0,
        targetType: 'enemy',
        duration: 0,
        levelReq: 1,
        description: '发射火球，命中附带灼烧3s持续伤害',
        effects: [{ type: 'dot', value: 0.15, duration: 3 }],
    },
    {
        id: 'dao_thunder',
        name: '雷霆万钧',
        faction: 'dao',
        cooldown: 10,
        mpCost: 35,
        damageType: 'magical',
        damageRatio: 2.2,
        range: 15,
        radius: 5,
        targetType: 'area',
        duration: 0,
        levelReq: 1,
        description: '目标区域召唤雷电，造成伤害并眩晕1.5s',
        effects: [{ type: 'stun', value: 1, duration: 1.5 }],
    },
    {
        id: 'dao_blink',
        name: '五行遁术',
        faction: 'dao',
        cooldown: 12,
        mpCost: 20,
        damageType: 'magical',
        damageRatio: 0,
        range: 12,
        radius: 0,
        targetType: 'area',
        duration: 0,
        levelReq: 5,
        description: '闪现至目标地点，途经敌人减速40%持续2s',
        effects: [{ type: 'slow', value: 0.4, duration: 2 }],
    },
    {
        id: 'dao_buff',
        name: '紫气东来',
        faction: 'dao',
        cooldown: 18,
        mpCost: 30,
        damageType: 'magical',
        damageRatio: 0,
        range: 0,
        radius: 0,
        targetType: 'self',
        duration: 6,
        levelReq: 8,
        description: '紫气状态6s，法术伤害+25%，施法不可被打断',
        effects: [{ type: 'buff_atk', value: 0.25, duration: 6 }],
    },
    {
        id: 'dao_ult',
        name: '九天玄火阵',
        faction: 'dao',
        cooldown: 35,
        mpCost: 100,
        damageType: 'magical',
        damageRatio: 1.0,
        range: 18,
        radius: 8,
        targetType: 'area',
        duration: 4,
        levelReq: 15,
        description: '大范围天火流星雨，持续4s每秒高额伤害',
    },
    {
        id: 'dao_pull',
        name: '乾坤挪移',
        faction: 'dao',
        cooldown: 15,
        mpCost: 40,
        damageType: 'magical',
        damageRatio: 0.5,
        range: 12,
        radius: 0,
        targetType: 'enemy',
        duration: 2,
        levelReq: 10,
        description: '将目标拉到面前并禁锢2s',
        effects: [{ type: 'pull', value: 1, duration: 2 }],
    },
];
// ==================== 少林金刚技能 ====================
const monkSkills = [
    {
        id: 'monk_basic',
        name: '伏魔杖法',
        faction: 'monk',
        cooldown: 0,
        mpCost: 0,
        damageType: 'physical',
        damageRatio: 0.9,
        range: 2.5,
        radius: 0,
        targetType: 'enemy',
        duration: 0,
        levelReq: 1,
        description: '禅杖横扫，每5次普攻回复自身3%最大生命',
        effects: [{ type: 'heal', value: 0.03, duration: 0 }],
    },
    {
        id: 'monk_taunt',
        name: '金刚怒目',
        faction: 'monk',
        cooldown: 10,
        mpCost: 25,
        damageType: 'physical',
        damageRatio: 0.5,
        range: 0,
        radius: 8,
        targetType: 'self',
        duration: 3,
        levelReq: 1,
        description: '嘲讽周围8m敌人攻击自己3s，自身减伤30%',
        effects: [{ type: 'buff_def', value: 0.3, duration: 3 }],
    },
    {
        id: 'monk_heal',
        name: '大慈大悲',
        faction: 'monk',
        cooldown: 14,
        mpCost: 35,
        damageType: 'magical',
        damageRatio: 0,
        range: 10,
        radius: 10,
        targetType: 'self',
        duration: 0,
        levelReq: 5,
        description: '恢复自身和周围友方各15%最大生命',
        effects: [{ type: 'heal', value: 0.15, duration: 0 }],
    },
    {
        id: 'monk_block',
        name: '铜墙铁壁',
        faction: 'monk',
        cooldown: 16,
        mpCost: 30,
        damageType: 'physical',
        damageRatio: 0,
        range: 0,
        radius: 0,
        targetType: 'self',
        duration: 4,
        levelReq: 8,
        description: '格挡姿态4s，正面伤害减少60%，反弹10%伤害',
        effects: [{ type: 'buff_def', value: 0.6, duration: 4 }],
    },
    {
        id: 'monk_ult',
        name: '降龙伏虎',
        faction: 'monk',
        cooldown: 30,
        mpCost: 80,
        damageType: 'physical',
        damageRatio: 2.5,
        range: 0,
        radius: 6,
        targetType: 'self',
        duration: 0,
        levelReq: 15,
        description: '跃起猛击地面，大范围伤害并击飞敌人，获得20%减伤5s',
        effects: [
            { type: 'knockback', value: 5, duration: 0 },
            { type: 'buff_def', value: 0.2, duration: 5 },
        ],
    },
    {
        id: 'monk_invincible',
        name: '般若金身',
        faction: 'monk',
        cooldown: 45,
        mpCost: 50,
        damageType: 'physical',
        damageRatio: 0,
        range: 0,
        radius: 0,
        targetType: 'self',
        duration: 3,
        levelReq: 10,
        description: '金身3s，免疫所有伤害和控制，但无法移动和攻击',
        effects: [{ type: 'shield', value: 999, duration: 3 }],
    },
];
// ==================== 暗影唐门技能 ====================
const shadowSkills = [
    {
        id: 'shadow_basic',
        name: '暴雨梨花针',
        faction: 'shadow',
        cooldown: 0,
        mpCost: 0,
        damageType: 'physical',
        damageRatio: 0.7,
        range: 8,
        radius: 0,
        targetType: 'enemy',
        duration: 0,
        levelReq: 1,
        description: '快速暗器，攻速快伤害低，第4次无视20%防御',
    },
    {
        id: 'shadow_dash',
        name: '鬼影步',
        faction: 'shadow',
        cooldown: 6,
        mpCost: 15,
        damageType: 'physical',
        damageRatio: 0,
        range: 8,
        radius: 0,
        targetType: 'area',
        duration: 1,
        levelReq: 1,
        description: '极速位移，途中获得1s隐身，可穿越敌人',
        effects: [{ type: 'stealth', value: 1, duration: 1 }],
    },
    {
        id: 'shadow_poison',
        name: '千蛛万毒',
        faction: 'shadow',
        cooldown: 10,
        mpCost: 30,
        damageType: 'physical',
        damageRatio: 0.5,
        range: 6,
        radius: 4,
        targetType: 'direction',
        duration: 6,
        levelReq: 5,
        description: '前方扇形喷洒毒雾，中毒6s持续伤害，降低治疗50%',
        effects: [{ type: 'dot', value: 0.2, duration: 6 }],
    },
    {
        id: 'shadow_assassinate',
        name: '影杀',
        faction: 'shadow',
        cooldown: 14,
        mpCost: 40,
        damageType: 'physical',
        damageRatio: 2.5,
        range: 2.5,
        radius: 0,
        targetType: 'enemy',
        duration: 3,
        levelReq: 8,
        description: '隐身3s，解除隐身首击250%伤害，背刺350%',
        effects: [{ type: 'stealth', value: 1, duration: 3 }],
    },
    {
        id: 'shadow_ult',
        name: '天女散花',
        faction: 'shadow',
        cooldown: 28,
        mpCost: 70,
        damageType: 'physical',
        damageRatio: 0.8,
        range: 0,
        radius: 8,
        targetType: 'self',
        duration: 3,
        levelReq: 15,
        description: '跃至空中抛洒暗器雨，大范围持续伤害，免疫地面技能',
    },
    {
        id: 'shadow_decoy',
        name: '移形换影',
        faction: 'shadow',
        cooldown: 20,
        mpCost: 25,
        damageType: 'physical',
        damageRatio: 1.5,
        range: 5,
        radius: 3,
        targetType: 'self',
        duration: 0,
        levelReq: 10,
        description: '留下残影后退5m，残影被攻击时爆炸造成伤害并减速',
        effects: [
            { type: 'stealth', value: 1, duration: 2 },
            { type: 'slow', value: 0.4, duration: 2 },
        ],
    },
];
// ==================== 导出所有技能 ====================
export const ALL_SKILLS = [
    ...swordSkills,
    ...daoSkills,
    ...monkSkills,
    ...shadowSkills,
];
export function getSkillsByFaction(faction) {
    return ALL_SKILLS.filter(s => s.faction === faction);
}
export function getSkillById(id) {
    return ALL_SKILLS.find(s => s.id === id);
}
